// friendService.js
// Servicio para manejar operaciones relacionadas con perfiles de amigos en Supabase.
// Centraliza todas las llamadas async a la base de datos para perfiles de amigos.
// Adaptado para web desde amarsi-app.

import { supabase } from '../lib/supabase';

// Obtiene el perfil social de un amigo.
// Llama a la función RPC user_profile_social con el ID del amigo.
export const getFriendProfile = async (friendId) => {
  const { data, error } = await supabase.rpc('user_profile_social', {
    friend_id: friendId,
  });
  if (error) throw error;
  return data;
};

// Obtiene las interacciones entre el usuario actual y un amigo.
// Llama a la función RPC interactions_between_us con IDs de usuario actual y amigo.
export const getFriendInteractions = async (currentId, friendId) => {
  const { data, error } = await supabase.rpc('interactions_between_us', {
    current_id: currentId,
    friend_id: friendId,
  });
  if (error) throw error;
  return data;
};

// Gestiona interacciones (como visitas o likes).
// Llama a la función RPC register_interaction_v2 con INSERT puro para historial completo.
export const manageInteraction = async (params) => {
  const { data, error } = await supabase.rpc('register_interaction_v2', params);
  if (error) throw error;
  return data;
};

// Obtiene los contadores de interacciones de un usuario de forma rápida.
// Consulta la tabla interaction_counter optimizada para lecturas rápidas.
export const getUserInteractionCounts = async (userId) => {
  const { data, error } = await supabase
    .from('interaction_counter')
    .select('*')
    .eq('user_id', userId)
    .single();
  if (error) throw error;
  return data;
};

// Obtiene el historial de interacciones paginado.
// Consulta la tabla interactions con historial completo.
export const getInteractionHistory = async (userId, page = 1, limit = 20) => {
  const offset = (page - 1) * limit;
  const { data, error } = await supabase
    .from('interactions')
    .select('*')
    .eq('destinatario', userId)
    .order('created_at', { ascending: false })
    .range(offset, offset + limit - 1);
  if (error) throw error;
  return data;
};

// Bloquea a un usuario insertando en la tabla unlinked.
// Inserta una entrada en 'unlinked' con gestor y bloqueado.
export const blockUser = async (gestorId, bloqueadoId) => {
  const { data, error } = await supabase
    .from('unlinked')
    .insert({ gestor: gestorId, bloqueado: bloqueadoId, created_at: new Date() })
    .select();
  if (error) throw error;
  return data;
};
